// extracted by mini-css-extract-plugin
export default {"databaseNameContainer":"Database_databaseNameContainer__2p3ZU","tableWrapper":"Database_tableWrapper__a-Sv4","tableWrapper_virtualized":"Database_tableWrapper_virtualized__2q6-v"};